import { string, bool, func, oneOfType, number, node } from 'prop-types'
import cn from 'classnames'

import s from './list-item.module.scss'

const ListItem = ({ label, isSelected, handleClick, componentRef, disabled, isChildItem, extraContent }) => (
  <li
    className={cn(s['list-item'], { [s['list-item-disabled']]: disabled, [s['list-item-child']]: isChildItem })}
    onClick={disabled ? () => {} : handleClick}
    role="option"
    aria-selected={isSelected}
    ref={componentRef}
  >
    <span className={s['list-item-label']}>{typeof label === 'string' ? label : String(label)}</span>
    {extraContent}
  </li>
)

ListItem.propTypes = {
  label: oneOfType([string, number]),
  isSelected: bool,
  handleClick: func,
  componentRef: func,
  disabled: bool,
  isChildItem: bool,
  extraContent: node,
}

export default ListItem
